<h4 class="title">
    {{panelTitle}}
</h4>
<ng-content></ng-content>
